export namespace CommonConstants {
  export const stateId: number = 6;
  export const passPhrase: String = "9Vv44rV9vA6LutX";
  //export const BaseUrl: String = "http://grhelpbihar.piramalswasthya.org/grsbe/public/api/v1/";
  // export const BaseUrl: String = "http://175.101.1.227/grsbepro/igemr1097/public/api/v1/";
  //export const BaseUrl: String = "http://192.168.45.54/grsbepro/igemr1097/public/api/v1/";
  export const BaseUrl: String = "https://grievance1097naco.piramalswasthya.org/grsbepro/igemr1097/public/api/v1/";

  export const invalidCaptcha: String = "Invalid captcha, please try again.";
  export const englishLanguage: String = "en";
  export const HindiLanguage: String = "hn";
  export const MaxValidation: Number = 100;
  export const validationMessage: String =
    "Something went wrong. Please try again later";
  export const noResultFound: String = "No Result Found";
  export const level: any = [
    { id: 0, name: "State" },
    { id: 1, name: "Division" },
    { id: 2, name: "District" },
    { id: 3, name: "Block" },
  ];

  export const status: any = [
    { id: 1, name: "Accept" },
    { id: 2, name: "Pending" },
    { id: 3, name: "Reject" },
  ];

  export const state: any = [
    { id: 1, name: "Bihar" },
    { id: 2, name: "Andhra Pradesh" }
  ];
  export const districts: any = [
    {
      id: 1, name: "Hyderabad"
    },
    { id: 2, name: "Andhra Pradesh" }
  ];

  export const districts1: any = [
    {
      id: 1,
      districts: [
        { id: 1, name: "Hyderabad" },
        { id: 2, name: "Warangal" }
      ],
    },
    {
      id: 2,
      districts: [
        { id: 1, name: "Nelluru" },
        { id: 2, name: "Kadapa" }
      ]
    }
    // 
  ];

  export const roleLevel: { id: string; name: string }[] = [
    { id: '1', name: "Level 1" },
    { id: '2', name: "Level 2" },
    { id: '3', name: "Level 3" },
    { id: '4', name: "Level 4" },
    { id: '5', name: "Level 5" },

  ];


  export const userType = [
    { id: 1, name: "State" },
    { id: 2, name: "NACO" }
  ]
  export const gender: any = [
    { id: "M", name: "Male" },
    { id: "F", name: "Female" },
    { id: "T", name: "Transgender " },
    { id: "O", name: "Other" },
  ];
  export const title: any = [
    { id: 0, name: "Mr" },
    { id: 1, name: "Mrs" },
    { id: 2, name: "Ms" },
    { id: 3, name: "Dr" },
  ];
  export const relationStatus: any = [
    { id: 0, name: "Father" },
    { id: 1, name: "Husband" },
  ];
  export const maritalStatus: any = [
    { id: 0, name: "Single" },
    { id: 1, name: "Married" },
    { id: 2, name: "Divorced" },
    { id: 3, name: "Widowed" },
  ];
  export const community: any = [
    { id: 0, name: "Community 1" },
    { id: 1, name: "Community 2" },
    { id: 2, name: "Community 3" },
  ];
  export const religion: any = [
    { id: 0, name: "Hinduism" },
    { id: 1, name: "Islam" },
    { id: 2, name: "Sikh" },
    { id: 3, name: "Christanity" },
    { id: 4, name: "Jain" },
  ];
  export const statusActionGrievance: any = [
    { name: "Resolved", dpname: "resolved" },
    { name: "Unresolved", dpname: "unresolved" },
    { name: "Partially" + "" + " Resolved", dpname: "partiallyresolved" },
    { name: "Rejected", dpname: "rejected" },
    { name: "On Hold", dpname: "onhold" },
  ];
  export const CanCloseGrievance: any = [
    { id: 0, name: "Yes" },
    { id: 1, name: "No" },
  ];
  export const timeUnit: any = ["month", "week", "day", "hour", "minute"];
  export const reminderType: any = ["sms", "email", "both"];
  export const checkBeforeAddressType: number = 0;
  export const checkBeforeAddressTypeName: string = "current";
  export const checkAfterAddressType: number = 1;
  export const checkAfterAddressTypeName: string = "permanent";
  export const countries = [{ id: 1, name: "india" }];
  export const defaultTime: number = 5000;
  export const defaultTimeOut: number = 5000;
  export const regexName = "/^[a-zA-Z]/";
  export const regexNotAllowSpecialCharacters = "^([a-zA-Z ]*)$";
  export const regexNotAllowSpace = "^[a-zA-Z]+$";
  export const regexNotAllowSpaceUserName = "^[a-zA-Z0-9_\S]+$";
  export const regexPinCode = "^[1-9][0-9]{5}$";
  export const regexAadharNumber = "[0-9]{12}";
  export const MobileOTP = "[0-9]{6}";
  export const regexMobileNumber = "^[0-9]{10,10}$";//^[6-9][0-9]{9}$
  export const regexNotAllowZeroMobileNumber = "^(?!0000000000)([6-9][0-9]{9})$";//
  export const regexPanNo = "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$";
  export const defaultCountry: String = "india";
  export const defaultCountryCode: any = "IND";
  export const recaptchSiteKey: any =
    "6Lf27qwUAAAAADT8N_nPDROK3WmDtJVr5pptAnGl";
  export const mobileNumberRegex: any = "^[0-9]{10,15}$";
  export const passwordRegex: any =
    "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$";
  export const passwordNotAllowSpaceRegex: any =
    "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=[^!@#$%_]*[!@#$%_][^!@#$%_]*)[a-zA-Z0-9!@#$%_]{8,}$";//"^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=[^!@#$%_]*[!@#$%_][^!@#$%_]*$)[a-zA-Z0-9!@#$%_]{8,}$"; 
  export const statesMessage: any = "Please Add States.";
  export const districtsMessage: any = "Please Add Districts.";
  export const roleMessage: any = "Please Add Roles.";
  export const talukasMessage: any = "Please Add Talukas.";
  export const villageMessage: any = "Please Add Villages.";
  export const statesNotAvailable: any = "States are not available.";
  export const levelsNotAvailable: any = "Levels are not available.";
  export const districtsNotAvailable: any = "Districts are not available.";
  export const validationsGender: any = "Select Gender";
  export const validationsState: any = "Select Gender";
  export const validationsDistrict: any = "Select District";
  export const validationsTaluka: any = "Select Taluka";
  export const validationsVillage: any = "Select Village";
  export const passwordDefaultValue: any = "password";
  export const passwordDefaultConfirmValue: any = "password";
  export const maxLength150: number = 150;
  export const maxLength100: number = 100;
  export const maxLength200: number = 2000;
  export const maxLength250: number = 250;
  export const maxLength2500: number = 2500;
  export const emailRegex: any = "^[a-z._%+-]+[a-z0-9._%+-]*@[a-z0-9.-]+\.[a-z]{2,4}$";// "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  export const ipdOpdRegex: any = "^.{1,32}$";
  export const blockWiseReport: string = "block-report";
  export const districtWiseReport: string = "district-wise-report";
  export const monthlyWiseReport: string = "month-mise-report";
  export const complaintSummaryWiseReport: string = "grievance-summary-report";
  export const complaintTypeWiseReport: string = "grievance-type-report";
  export const natureComplaintWiseReport: string = "grievance-nature-report";
  export const menu = {
    "1": {
      name: "Home",
      slug: "admin-dashboard",
      uri: "admin-dashboard",
      menu_class: "fa fa-home nav-icon",
    },
    "6": {
      name: "Accounts",
      slug: "",
      uri: "",
      menu_class: "fa fa-user-plus nav-icon",
      sub_menu: [
        {
          name: "Users",
          slug: "users",
          uri: "user",
          menu_class: "",
        },
      ],
    },
    "15": {
      name: "Tools",
      slug: "",
      uri: "",
      menu_class: "fa fa-cog nav-icon",
      sub_menu: [
        {
          name: "Manage Roles",
          slug: "roles",
          uri: "roles",
          menu_class: "",
        },
      ],
    },
  };

  export const complaintData: any =
    [
      {
        "complaintID": "comp120",
        "complaintDate": "	16/10/2022, 1:55 PM",
        "subjectofcomplaint": " Doctors are not available in their shift daily in ENT",
        "state": "Telangana",
        "district": "Hyderabad",
        "block": "Complex",
        "status": "Pending",
        "registeredBy": "Ramu"
      },
      {
        "complaintID": "comp121",
        "somplaintDate": "	16/10/2022, 1:58 PM",
        "subjectofcomplaint": " Doctors are not available in their shift daily",
        "state": "Telangana",
        "district": "Hyderabad",
        "block": "Complex",
        "status": "Pending",
        "registeredBy": "Ramu"
      },
      {
        "complaintID": "comp122",
        "somplaintDate": "	16/10/2022, 1:59 PM",
        "subjectofcomplaint": " Doctors are not available in their shift daily",
        "state": "Telangana",
        "district": "Hyderabad",
        "block": "Complex",
        "status": "Pending",
        "registeredBy": "Ramu"
      },
      {
        "complaintID": "comp123",
        "somplaintDate": "	16/10/2022, 2:00 PM",
        "subjectofcomplaint": " Doctors are not available in their shift daily in ENT",
        "state": "Telangana",
        "district": "Hyderabad",
        "block": "Complex",
        "status": "Pending",
        "registeredBy": "Ramu"
      }
      ,
      {
        "complaintID": "comp120",
        "somplaintDate": "	16/10/2022, 2:15 PM",
        "subjectofcomplaint": " Doctors are not available in their shift daily in ENT",
        "state": "Telangana",
        "district": "Hyderabad",
        "block": "Complex",
        "status": "Pending",
        "registeredBy": "Ramu"
      }
    ]

}
